import { apiCall, apiCallPublic, baseUrl } from './config';
import { shouldUseMock } from '../../utils/common';
import {
  getLoginMock,
  getOTPLoginMock,
  refreshTokenMock,
  restorePasswordMock,
} from './mock';
import { authPath } from '../../utils/paths';

export default {
  login: (params) => {
    if (shouldUseMock()) {
      return getLoginMock();
    }
    return apiCallPublic(`${baseUrl}${authPath}login`, 'POST', params);
  },
  loginOTP: (params) => {
    if (shouldUseMock()) {
      return getOTPLoginMock();
    }
    return apiCallPublic(`${baseUrl}${authPath}login/otp`, 'POST', params);
  },
  loginSSO: (params) => {
    if (shouldUseMock()) {
      return getOTPLoginMock();
    }
    return apiCallPublic(`${baseUrl}${authPath}login_sso`, 'POST', params);
  },
  refreshToken: (params) => {
    if (shouldUseMock()) {
      return refreshTokenMock();
    }
    return apiCall(`${baseUrl}${authPath}token/refresh`, 'POST', params);
  },
  restorePassword: (params) => {
    if (shouldUseMock()) {
      return restorePasswordMock();
    }
    return apiCallPublic(`${baseUrl}${authPath}reset`, 'POST', params);
  },
  resetWithToken: ({ token, new_password }) => {
    if (shouldUseMock()) {
      return restorePasswordMock();
    }
    return apiCallPublic(
      `${baseUrl}${authPath}change`,
      'POST',
      { new_password },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
  },
};
